
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"31","height":"28","viewBox":"0 0 31 28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 139472"}},[_c('circle',{attrs:{"data-name":"Ellipse 6360","cx":"10","cy":"10","r":"10","transform":"translate(0 5)","fill":"#2d257d"}}),_c('circle',{attrs:{"data-name":"Ellipse 6362","cx":"2.5","cy":"2.5","r":"2.5","transform":"translate(26 6)","fill":"#f7921e"}}),_c('circle',{attrs:{"data-name":"Ellipse 6361","cx":"8.5","cy":"8.5","r":"8.5","transform":"translate(7)","fill":"#fac40b"}}),_c('circle',{attrs:{"data-name":"Ellipse 6363","cx":"8.5","cy":"8.5","r":"8.5","transform":"translate(11 11)","fill":"#f7921e"}})])])
          )
        }
      }
    